import { useRouter } from 'next/router';

type RouterParam = {
  router: ReturnType<typeof useRouter>;
  projectId: number;
  assignmentId: number;
};

export const useRouterParam = (): RouterParam => {
  const router = useRouter();
  const { query: { id: projectId, assignmentId } } = router;

  return {
    router,
    projectId: Number(projectId),
    assignmentId: Number(assignmentId),
  };
};
